import _ from 'lodash';
import {
   FETCH_GAME_STATES,
} from "../constants/ActionTypes";
// import {IS_PRIVATE, TITLE} from "../constants/Game";

/*
 * Reducer for game state.
 *
 * React/Redux passes in the previous state, and for the new data an action type and an action payload
 *
 * If the type is what we're looking for, update the state with the payload.
 *
 * Think of the state as all the game-states we've downloaded in this session, which will be a subset of all the
 * game states in the system.   And collated into two collections, one with collections of gameStates for each userId,
 * and one for collections of gameStates for each gameId
 *
 */

export default function (state = null, action) {

   switch (action.type) {
      case FETCH_GAME_STATES:
         const fetchedGameStates = action.payload;

         // if there is no new data, just return the existing state
         if (!fetchedGameStates) {
            return state;
         }
         else {
            // Collate our data by user and game.  Form two collections:
            var newByUser = {};
            var newByGame = {};

            // foreach state in collection
            _.forEach(fetchedGameStates, function (value, key) {
               if (!newByUser[value.userId]) {
                  newByUser[value.userId] = {};
               }
               newByUser[value.userId][value.gameId] = value;
               if (!newByGame[value.gameId]) {
                  newByGame[value.gameId] = {}
               }
               newByGame[value.gameId][value.userId] = value;
            });

            // if there is no existing state, return just the new data
            if (!state) {
               return {byUser: newByUser, byGame: newByGame};
            } else {
               // existing and new data.  So, merge.

               // start with a new map, populated with existing map entries.
               const combinedByUser = {...state.byUser, ...newByUser};
               const combinedByGame = {...state.byGame, ...newByGame};
               return {byUser: combinedByUser, byGame: combinedByGame};
            }
         }
      default:
         return state
   }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_gamestates.js